import { render, staticRenderFns } from "./RequerimientoObservaciones.vue?vue&type=template&id=7375769f&scoped=true&"
import script from "./RequerimientoObservaciones.vue?vue&type=script&lang=js&"
export * from "./RequerimientoObservaciones.vue?vue&type=script&lang=js&"
import style0 from "./RequerimientoObservaciones.vue?vue&type=style&index=0&id=7375769f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7375769f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VTextarea,
})
